





























































import {
  Vue,
  Component,
  State,
  namespace,
  Watch,
  Prop
} from 'nuxt-property-decorator'
import throttle from 'lodash/throttle'
import cloneDeep from 'lodash/cloneDeep'
import RangesLayout from './new-ranges-layout.vue'
import CategoryLayout from './new-category-layout.vue'
import { filterRangeDataByCountry } from '~/components/experience/search-filter/mobile/search-filter-ab/utils'
import { Experience } from '~/types/experience'
import CategoryTree from '~/components/experience/destinations-category-tree/category-tree.vue'
import RangesTree from '~/components/experience/destinations-category-tree/ranges-tree.vue'
import TreeModel from '~/components/experience/destinations-category-tree/tree-model'

import TreeNode = Experience.TreeNode
import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component({
  components: {
    CategoryTree,
    RangesTree,
    RangesLayout,
    CategoryLayout
  }
})
export default class ModalTree extends Vue {
  @State klook!: Data.Klook
  @experience.State categoryTreeData!: TreeNode[]
  @experience.State rangeData!: TreeNode[]
  @experience.State urlQuery!: UrlQuery
  @experience.Action setUrlQuery!: Function
  @experience.Action setSelectedCategory!: Function
  @experience.Action setSelectedRanges!: Function
  @Prop() type!: 'range' | 'category'
  @Prop() isAbExperiment!: boolean
  @Prop() visible!: boolean
  @Prop() isGlobal!: boolean
  // @Prop() isScroll!: boolean

  // 缓存选择的国家内容，用于在已有选项的情况下，点击清除按钮，或者关闭弹窗，重置数据

  showExperimentInput: boolean = false // 是否显示搜索栏
  isScrolling: boolean = false
  keyword: string = ''
  searchResultData: TreeNode[] = []
  ranges: TreeNode[] = []
  category: TreeNode[] = []
  searchResult: TreeNode[] = []
  throttleSearch: Function = throttle(this.search, 500)
  selectedRange: any = []
  selectedCategory: any = []
  _backupRangesData: TreeNode[] = [] // 缓存rangesdata
  _backupCategoryData: TreeNode[] = [] // 缓存Categorydata
  searchVisible: boolean = false // 是否显示searchLayout

  get expandAll() {
    return this.klook.platform === 'desktop'
  }

  get placeholder() {
    const rangePlaceholder = this.$t('index.citylist.city')
    const categoryPlaceholder = this.$t('15620')
    return this.type === 'range'
      ? this.$t('5301', rangePlaceholder)
      : this.$t('5301', categoryPlaceholder)
  }

  @Watch('keyword')
  keywordChange() {
    if (this.keyword === '') {
      if (this.isAbExperiment && !this.isGlobal) {
        this.showExperimentInput = false
      } else {
        this.ranges = cloneDeep(this._backupRangesData)
        this.category = cloneDeep(this._backupCategoryData)
        this.searchVisible = false
      }
    } else {
      this.throttleSearch()
      this.searchVisible = true
    }
  }

  resetRangesData(data: TreeNode[]) {
    const _data = this.getFilterData(cloneDeep(data))

    if (!this.isGlobal) {
      this.ranges = filterRangeDataByCountry(_data)
      this.showExperimentInput = false
    } else {
      this.ranges = _data
      this.showExperimentInput = true
    }

    this._backupRangesData = cloneDeep(this.ranges)
  }

  /**
   * 在已获取到的数据中，根据关键字，进行前端本地静态过滤
   * 修改数据的show字段，展示完整的数据。不像之前的树结构， 只展示匹配到的节点内容
   * 1、父节点被命中，可以直接展示父节点和checkbox，通过country_id，可以过滤目的地
   * 2、子节点一旦被命中，父辈节点都需要展示
   * **/
  search(data?: TreeNode[]) {
    const treeData =
      this.type === 'range' ? this._backupRangesData : this._backupCategoryData
    const _data = data || treeData
    const searchResult = this.getFilterData(this.filteDataByKeyword(_data))
    new TreeModel().fixParentNodeChecked(searchResult, this.type)
    this.searchResultData = searchResult
  }

  setShowAttrByMathWord(
    source: TreeNode[],
    word: string = this.keyword,
    isChecked?: boolean
  ): void {
    source.forEach((item: TreeNode) => {
      const { title } = item
      this.$set(item, 'show', isChecked || this.matchWord(title, word))
    })
  }

  // 用栈的概念将每一节打散，分别判断，最后在拼接在一起，返回即可
  filteDataByKeyword(data: TreeNode[]) {
    const result: any[] = []
    data.forEach((item: TreeNode) => {
      const list: any = []
      const { children } = item
      list.unshift(item)
      list.unshift(children || [])
      result.push(this.composeSearchData(list))
    })
    return result as TreeNode[]
  }

  // 拼接搜索结果数据
  composeSearchData(data: any[]) {
    const [secLevel, topLevel] = data
    topLevel.children = secLevel
    secLevel.forEach((item: any) => {
      // 这里需要注意category只有两层数据结构
      const { children } = item
      this.setShowAttrByMathWord([item])
      // 加一个逻辑判断。如果country节点命中关键字,，无需再判断子节点的命中情况，子节点全部显示。直接跳出循环
      if (item.show) {
        (children && children.length) && this.setShowAttrByMathWord(children, this.keyword, true)
        return null
      } else if (children && children.length) {
        this.setShowAttrByMathWord(children)
        if (this.getChildrenShow(children)) {
          // 如果子节点有命中关键字的数据，就设置父节点的show属性为true
          this.$set(item, 'show', true)
        }
      }
    })

    // 兼容没有子节点的情况
    let showTopLevel = false
    // 兼容category节点
    if (this.type === 'category' && this.matchWord(topLevel.title)) {
      if (secLevel.length) {
        this.setShowAttrByMathWord(topLevel.children, this.keyword, true)
      } else {
        // 兼容没有子节点的情况
        showTopLevel = true
      }
    }
    // @Notice: 这个节点必须放在最后，保证所有子节点的状态都已经设置完毕，再根据子节点反推父节点的show属性
    this.$set(topLevel, 'show', this.getChildrenShow(secLevel) || showTopLevel)
    return topLevel
  }

  // 判断子节点show属性情况
  getChildrenShow(data: TreeNode[]) {
    return data.some((item: TreeNode) => item.show)
  }

  matchWord(sourceWord: string, keyword: string = this.keyword) {
    const reg = /\s+/g
    const _keyword = keyword.replace(reg, '').toLocaleLowerCase()
    const source = sourceWord.replace(reg, '').toLocaleLowerCase()
    return source.includes(_keyword)
  }

  /**
   * 该函数会修改原数据的show字段，导致数据前后不一致（bug代码）
   * */
  initData(data?: TreeNode[]) {
    const treeData = this.type === 'range' ? this.ranges : this.category
    const d = data || treeData
    d.forEach((item: TreeNode) => {
      item.show = true
      item.expand = this.klook.platform === 'desktop'
      item.children && this.initData(item.children)
    })
  }

  rangeChange(data: any) {
    const { countryId, cityId } = data.selected
    this.selectedRange = data.selected
    const country = Object.keys(countryId || []).join(',')
    const city = Object.keys(cityId || []).join(',')
    const confirm = document.querySelector(
      '.js-tree-modal-confirm'
    ) as HTMLElement
    this.$inhouse.updateBinding(confirm, {
      ext: JSON.stringify({
        country_id: country,
        city_id: city
      })
    })
    this.$emit('rangeChange', this.selectedRange, cloneDeep(data.ranges))
  }

  // 同步子组件的数据到backup数据中
  changeBackupData(data: TreeNode[]) {
    if (this.type === 'range') {
      this._backupRangesData = cloneDeep(data)
    } else {
      this._backupCategoryData = cloneDeep(data)
    }
  }

  categoryChange(data: any) {
    this.selectedCategory = data.selected
    const category = Object.keys(this.selectedCategory || []).join(',')
    const confirm = document.querySelector(
      '.js-tree-modal-confirm'
    ) as HTMLElement
    this.$inhouse.updateBinding(confirm, {
      ext: JSON.stringify({ categorytree_id: category })
    })
    this.$emit('categoryChange', this.selectedCategory)
  }

  clearAll(data?: TreeNode[]) {
    const treeData = this.type === 'range' ? this.ranges : this.category
    const d = data || treeData
    d.forEach((item: TreeNode) => {
      item.show = true
      item.checked = false
      // delete item.indeterminate
      // item.expand = false
      item.children && this.clearAll(item.children)
    })
  }

  parentClearAll() {
    this.clearAll()
    this.ranges = cloneDeep(this.ranges)
    this.category = cloneDeep(this.category)
    this.searchVisible = false
    this._backupRangesData = cloneDeep(this.ranges)
    this._backupCategoryData = cloneDeep(this.category)
    this.$emit('rangeChange', this.ranges)
  }

  closeModal() {
    this.$emit('close')
  }

  // 过滤disabled => true show => false 的数据
  getFilterData(data: TreeNode[]): TreeNode[] {
    const _data = JSON.parse(JSON.stringify(data))
    const list: TreeNode[] = []
    _data.forEach((_item: TreeNode) => {
      const { show, disabled, children } = _item
      if (show && !disabled) {
        if (children && children.length) {
          const res = this.getFilterData(children)
          _item.children = [...res]
        }
        list.push(_item)
      }
    })
    return list
  }

  resetRangeAndCategoryData() {
    this.ranges = this.getFilterData(this.rangeData)
    this.category = this.getFilterData(this.categoryTreeData)

    if (this.isAbExperiment) {
      if (!this.isGlobal) {
        this.ranges = filterRangeDataByCountry(this.ranges)
        this.showExperimentInput = false
      } else {
        this.showExperimentInput = true
      }
    }
  }

  resetKeyword() {
    this.keyword = ''
  }

  created() {
    this.resetRangeAndCategoryData()
    this._backupRangesData = cloneDeep(this.ranges)
    this._backupCategoryData = cloneDeep(this.category)
  }
}
